import { render, staticRenderFns } from "./ChooseQualificationModal.vue?vue&type=template&id=2952969b&"
import script from "./ChooseQualificationModal.vue?vue&type=script&lang=js&"
export * from "./ChooseQualificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports